export default __webpack_public_path__ + "static/media/AWS-CCP.d7cf16df.md";